var mobile = false;
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
 	mobile = true;
}

// Place your custom JavaScript here.
$(document).ready(function () {
	function debounce(fn, delay) {
		var timer = null;
		return function () {
		  var context = this, args = arguments;
		  clearTimeout(timer);
		  timer = setTimeout(function () {
			fn.apply(context, args);
		  }, delay);
		};
	  }
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
		if ($(this).innerWidth() / $(this).innerHeight() > 1.5) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			$(this).wrap("<div class='responsive-embed'/>");
		}
	});

	$("[data-toggle='top-bar-overlay']").click(() => {
		$("body").toggleClass("no-scroll");
	});

	// overlap elements
	var overlap = $(".line-elem-container:not(.hide-header-line)");
	var headerHeight = $(".top-bar").outerHeight();
	var topBar = $(".top-bar-left");

	if (!mobile) {

		checkCollision();

		$(document).on('scroll', function() {
			checkCollision();
		});
	}

	function checkCollision() {
		var scroll = $(document).scrollTop() + headerHeight;
		var doesOverlap = false;
		overlap.each(function() {
			var offsetTop = $(this).offset().top;
			var offsetBottom = offsetTop + $(this).outerHeight();			

			if ( ( scroll > offsetTop && scroll < offsetBottom ) || scroll <= headerHeight ) {

				// check for extra offset if needed

				var extraOffsetBottom = 0;
				var extraOffsetTop = 0;

				if( $(this).find(".line-left-center-white").length ) {
					extraOffsetBottom = 90;
					extraOffsetTop = 0;
				} else if ( $(this).find(".line-center-center-white").length ) {						
					extraOffsetBottom = 90;
					extraOffsetTop = 90;
				}

				if ( ( scroll > (offsetTop + extraOffsetTop) && scroll < (offsetBottom - extraOffsetBottom) ) || scroll <= headerHeight ) {
					doesOverlap = true;
				}

			}
		});



		if (doesOverlap == true) {
			topBar.addClass("line-visible");
		} else {			
			topBar.removeClass("line-visible");
		}
	}

	$(window).resize(debounce(fixLines, 250));

	function fixLines() {
		if ($(window).width() > 1233) {
			$('.line-center-center-right-white').toggleClass('line-center-center-right-white-big', true);
        	$('.line-center-center-left-white').toggleClass('line-center-center-left-white-big', true);
        	$('.line-left-center-white').toggleClass('line-left-center-white-big', true);
        	$('.line-2').toggleClass('line-2-big', true);
			$('.line-center-center-right-white').toggleClass('line-center-center-right-white', false);
        	$('.line-center-center-left-white').toggleClass('line-center-center-left-white', false);
        	$('.line-left-center-white').toggleClass('line-left-center-white', false);
			$('.line-2').toggleClass('line-2', false);
			
			var w = $(window).width() / 2;

			if (w % 1 == 0) {
				toggleOff();
			} else {
				toggleOn();
			}	
		} else {
			toggleOff();
			$('.line-center-center-right-white-big').toggleClass('line-center-center-right-white', true);
        	$('.line-center-center-left-white-big').toggleClass('line-center-center-left-white', true);
        	$('.line-left-center-white-big').toggleClass('line-left-center-white', true);
			$('.line-2-big').toggleClass('line-2', true);
			$('.line-center-center-right-white').toggleClass('line-center-center-right-white-big', false);
        	$('.line-center-center-left-white').toggleClass('line-center-center-left-white-big', false);
        	$('.line-left-center-white').toggleClass('line-left-center-white-big', false);
        	$('.line-2').toggleClass('line-2-big', false);
		}
	}

	function toggleOn() {
		$('.line-center-center-right-white-big').toggleClass('fix-before-small', true);
        $('.line-center-center-right-white-big').toggleClass('fix-after-long', true);
        $('.line-center-center-left-white-big').toggleClass('fix-before-small', true);
        $('.line-center-center-left-white-big').toggleClass('fix-left-after-long', true);
        $('.line-left-center-white-big').toggleClass('fix-after-small', true);
        $('.line-left-center-white-big').toggleClass('fix-before-long', true);
        $('.line-2-big').toggleClass('fix-line-2', true);
	}

	function toggleOff() {
		$('.line-center-center-right-white-big').toggleClass('fix-before-small', false);
        $('.line-center-center-right-white-big').toggleClass('fix-after-long', false);
        $('.line-center-center-left-white-big').toggleClass('fix-before-small', false);
        $('.line-center-center-left-white-big').toggleClass('fix-left-after-long', false);
        $('.line-left-center-white-big').toggleClass('fix-after-small', false);
        $('.line-left-center-white-big').toggleClass('fix-before-long', false);
        $('.line-2-big').toggleClass('fix-line-2', false);
	}

	fixLines();

	$(document).ready(function(){
		$(".number-button").click(function(){
		  $(".number-button").addClass("show").fadeIn();
		});
	  });

	  $(document).ready(function(){
		$(".menu-number").click(function(){
		  $(".menu-number").addClass("show").fadeIn();
		});
	  });

	const menus = document.querySelectorAll(".has-submenu");
	let i = 0;
	for (const menu of menus) {
		const randomID = "id-" + i++;
		menu.querySelector(".submenu").setAttribute("id", randomID);
		menu.querySelector(".toggle").setAttribute("data-toggle", randomID);

		$(`#${randomID}`).on("on.zf.toggler off.zf.toggler", function(event) {
			const parent = document.querySelector(`[data-toggle=${randomID}]`);
			const iconOpen = parent.getAttribute("data-toggle-open") || 'fa-arrow-up';
			const iconClosed = parent.getAttribute("data-toggle-closed") || 'fa-arrow-down';
			const svg = parent.querySelector("svg");
			const i = parent.querySelector("i");

			switch (event.type) {
				case "on":
					$(`#${randomID}`).slideDown();
					if (svg !== null) {
						svg.classList.add(iconOpen);
						svg.classList.remove(iconClosed);
					}
					if (i !== null) {
						i.classList.add(iconOpen);
						i.classList.remove(iconClosed);
					}
					break;
				case "off":
					$(`#${randomID}`).slideUp();
					if (svg !== null) {
						svg.classList.add(iconClosed);
						svg.classList.remove(iconOpen);
					}
					if (i !== null) {
						i.classList.add(iconClosed);
						i.classList.remove(iconOpen);
					}
					break;
			}
		});
	}

});